export default {
  isHandInCheckedHands: function (handInfo, drawInfo, checkedHands) {
    for (let key in checkedHands) {
      if (checkedHands.hasOwnProperty(key)) {
        if (checkedHands[key].isAHit(handInfo, drawInfo)) {
          return true;
        }
      }
    }

    return false;
  },
  getWeightOfLargestMatchingFiveCardHand: function (handInfo, drawInfo, checkedHands) {
    let weightOfLargestMatchingHand = 0;

    for (let key in checkedHands) {
      if (checkedHands.hasOwnProperty(key)) {
        if (checkedHands[key].isAHit(handInfo, drawInfo)) {
          if (checkedHands[key].weight === 100) {
            return 100;
          } else {
            weightOfLargestMatchingHand = checkedHands[key].weight;
          }
        }
      }
    }

    return weightOfLargestMatchingHand;

  },
};



// WEBPACK FOOTER //
// ./src/services/utilities/results.js